import { render, staticRenderFns } from "./RelatorioRetornouOrigemList.vue?vue&type=template&id=11ee90f6"
import script from "./RelatorioRetornouOrigemList.vue?vue&type=script&lang=js"
export * from "./RelatorioRetornouOrigemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports